import FootballStatsCategory from "../../../stats/football-stats-category";
import FootballState from "../../../state/football-state";
import StatsRule from "../../../../common/stats-rule";

export default class FumbleRecoveryStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            (fragment.associatedState === FootballState.FumbleRecovered ||
                fragment.associatedState ===
                    FootballState.FumbleNotRecovered) &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { recoveredBy } = fragment;
        const possessionPlayer = gameContext.getCurrentPlayerInPossession();
        const stats = [];
        this.addStats(
            {
                gameId: play.gameId,
                playId: play.id,
                period: gameContext.currentPeriod,
                teamId: recoveredBy.teamId,
                playerId: recoveredBy.id,
                driveId: gameContext.currentDriveId,
                fragmentId: fragment.id,
                category: FootballStatsCategory.FUMBLE_RECOVERED,
                values: { completed: 1 }
            },
            stats
        );

        if (possessionPlayer.teamId !== recoveredBy.teamId) {
            this.addStats(
                {
                    gameId: play.gameId,
                    playId: play.id,
                    period: gameContext.currentPeriod,
                    teamId: possessionPlayer.teamId,
                    playerId: possessionPlayer.id,
                    driveId: gameContext.currentDriveId,
                    fragmentId: fragment.id,
                    category: FootballStatsCategory.FUMBLE_LOST,
                    values: { completed: 1 }
                },
                stats
            );
        }

        return stats;
    }
}
